/** Auth user token key */
export const AUTH_USER_TOKEN_KEY = 'hjbc.TokenKey'
